import { render, staticRenderFns } from "./TryVideo.vue?vue&type=template&id=2a656485&lang=html"
import script from "./TryVideo.vue?vue&type=script&lang=js"
export * from "./TryVideo.vue?vue&type=script&lang=js"
import style0 from "./TryVideo.vue?vue&type=style&index=0&id=2a656485&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports